import { createNamespacedHelpers } from 'vuex-composition-helpers'
import { computed } from 'vue'

export function useBulkUpdate() {
  const { useGetters: usePermissionsGetters } = createNamespacedHelpers('permissions')
  const { canBulkApproveJobs, canBulkUpdateJobs } = usePermissionsGetters([
    'canBulkApproveJobs',
    'canBulkUpdateJobs',
  ])

  const bulkUpdateEnabled = computed<boolean>(() => {
    return canBulkUpdateJobs.value || canBulkApproveJobs.value
  })

  return bulkUpdateEnabled
}
